import { useContext } from 'react'
import { GlobalContext } from '../../common/global-context'
import { Navigate, Outlet } from 'react-router-dom'

export function MaintenanceGuard() {
    const { settings } = useContext(GlobalContext)

    if (settings?.maintenanceMode) {
        return <Navigate to="/" />
    }

    return <Outlet></Outlet>
}
